import { render } from "./EditWorkShift.vue?vue&type=template&id=249d2638&scoped=true"
import script from "./EditWorkShift.vue?vue&type=script&lang=js"
export * from "./EditWorkShift.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=249d2638&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249d2638"]])

export default __exports__